import React, { useState, useCallback, useEffect, forwardRef } from "react";
import { FormLayout, TextField, Text, RangeSlider } from "@shopify/polaris";
import { HexColorPicker } from "react-colorful";

const CustomCssStyle = (props) => {
  const handleSelectChangeCustomCss = (newValue) => {
    props.handleSelectChangeCustomCss(newValue);
  };

  return (
    <FormLayout>
      <Text variant="headingSm" as="h6">
        CUSTOM CSS
      </Text>

      <TextField
        value={props?.item?.customCss ? props?.item?.customCss : ""}
        onChange={handleSelectChangeCustomCss}
        multiline={4}
        placeholder="h2 {

          font-size: 32px;
          
        }"
      />
    </FormLayout>
  );
};

export default CustomCssStyle;
